//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from "../components/NavBar.vue";
import Popular from "../components/Popular.vue";
import UserCard from "../components/UserCard.vue";
import TweetTabs from "../components/TweetTabs.vue";
import CreateTweets from "../components/CreateTweet.vue";
export default {
  name: "Users",
  components: {
    UserCard,
    TweetTabs,
    NavBar,
    Popular,
    CreateTweets,
  },
  mounted() {
    this.fetchUserInfo();
  },
  data() {
    return {
      popularUpdate: false,
    };
  },
  methods: {
    async fetchUserInfo() {
      const pramsId = this.$route.params.id;
      await this.$store.dispatch("fetchUserInfo", { payload: pramsId });
    },
  },
};
